import { Action, createReducer, on } from '@ngrx/store';
import { GetSecurityOutput } from '@smash-sdk/iam/ejs/11-2023/types/GetSecurity/GetSecurity';
import { SecurityActions } from '../actions';
import { GetMfaOutput } from '@smash-sdk/iam/ejs/11-2023/types/GetMfa/GetMfa';


export const securityFeatureKey = 'security';

export interface State {
  mfa: GetMfaOutput['mfa'];
  
  security: GetSecurityOutput['security'];
  getSecurityLoading: boolean;
  getSecurityLoaded: boolean;
  getSecurityError: any;

  updateUserSecurityLoading: boolean;
  updateUserSecurityLoaded: boolean;
  updateUserSecurityError: any;
}

export const initialState: State = {
  mfa: null,

  security: null,
  getSecurityLoading: false,
  getSecurityLoaded: false,
  getSecurityError: null,

  updateUserSecurityLoading: false,
  updateUserSecurityLoaded: false,
  updateUserSecurityError: null,
};

const securityReducer = createReducer(
  initialState,

  // GetSecurity
  on(SecurityActions.GetSecurity, (state) => ({
    ...state,
    getSecurityLoading: true,
    getSecurityLoaded: false,
    getSecurityError: null,
  })),
  on(SecurityActions.GetSecuritySuccess, (state, { security }) => ({
    ...state,
    security,
    getSecurityLoading: false,
    getSecurityLoaded: true,
    getSecurityError: null,
  })),
  on(SecurityActions.GetSecurityFailure, (state, { error }) => ({
    ...state,
    getSecurityLoading: false,
    getSecurityLoaded: false,
    getSecurityError: error,
  })),

  // UpdateUserSecurity
  on(SecurityActions.UpdateUserSecurity, (state) => ({
    ...state,
    updateUserSecurityLoading: true,
    updateUserSecurityLoaded: false,
    updateUserSecurityError: null,
  })),
  on(SecurityActions.UpdateUserSecuritySuccess, (state, { security }) => ({
    ...state,
    security,
    updateUserSecurityLoading: false,
    updateUserSecurityLoaded: true,
  })),
  on(SecurityActions.UpdateUserSecurityFailure, (state, { error }) => ({
    ...state,
    updateUserSecurityLoading: false,
    updateUserSecurityLoaded: false,
    updateUserSecurityError: error,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return securityReducer(state, action);
}
